import { startOfWeek, startOfMonth, subMonths, startOfDay, addMonths, addWeeks, addDays } from 'date-fns';
import { DateFilterPickerPresets } from './DateFilterPicker.types';
const noFilterObj = {
    fromDate: null,
    toDate: null
};
export function getFormattedTimeRange(preset, now) {
    switch(preset){
        case DateFilterPickerPresets.AllTime:
            return noFilterObj;
        case DateFilterPickerPresets.Today:
            {
                const from = startOfDay(now);
                return {
                    fromDate: from.getTime(),
                    toDate: addDays(from, 1).getTime()
                };
            }
        case DateFilterPickerPresets.ThisWeek:
            {
                const from = startOfWeek(now);
                return {
                    fromDate: from.getTime(),
                    toDate: addWeeks(from, 1).getTime()
                };
            }
        case DateFilterPickerPresets.ThisMonth:
            {
                const from = startOfMonth(now);
                return {
                    fromDate: from.getTime(),
                    toDate: addMonths(from, 1).getTime()
                };
            }
        case DateFilterPickerPresets.PreviousMonth:
            {
                const to = startOfMonth(now);
                return {
                    fromDate: subMonths(to, 1).getTime(),
                    toDate: to.getTime()
                };
            }
        case DateFilterPickerPresets.LastThreeMonths:
            {
                const to = startOfMonth(now);
                return {
                    fromDate: subMonths(to, 3).getTime(),
                    toDate: to.getTime()
                };
            }
    }
}
export function isInRange(rangeObj, dateObj) {
    const timestamp = dateObj.getTime();
    return (rangeObj.fromDate || -Infinity) <= timestamp && timestamp <= (rangeObj.toDate || Infinity);
}
